module.exports = __webpack_public_path__ + "media/images/crime-trends-counties-2023-6dcdc334c632b7cd4c1b98d67b8631ab.png";